import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { defaultDropDownFilters, getColumns } from "./columnData";
import { Table } from "../../../components/Table";
import { Api } from "../../../services/api";
import { useAppSelector } from "../../../store/hooks";
import { handleAxiosError } from "../../../services/utils/handleAxiosError";
import { UserPermissions } from "../../../enums";
import { filterUniqueKeys } from "../../../services/utils/filterUniqueKeys";
import { Container } from "../Admin.styles";

export const Roles: React.FC = () => {
  const history = useHistory();
  const user = useAppSelector(state => state.auth.user);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any>([]);
  const [dropDownFilters, setDropFilters] = useState<any>(null);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    setIsLoading(true);

    try {
      const response: any = await Api.roles.getRoleList(user.accountId);
      const newDropDownFilters = filterUniqueKeys(
        response.data.roles,
        defaultDropDownFilters,
        Object.keys(defaultDropDownFilters)
      );

      setDropFilters(newDropDownFilters);
      setTableData(response.data.roles);
    } catch (error: unknown) {
      console.error("Roles fetch:", error);
      handleAxiosError(error);
    }

    setIsLoading(false);
  };

  let handleAddRole;
  if (user.permissions.includes(UserPermissions.RoleAddRole)) {
    handleAddRole = () => {
      const currentLocation = history.location;
      currentLocation.pathname = `${currentLocation.pathname}/add`;
      history.push(currentLocation);
    };
  }

  return (
    <Container>
      <Table
        searchable
        title="Roles"
        tableType="Roles"
        isLoading={isLoading}
        defaultRows={20}
        columns={getColumns()}
        rowsPerPage={[10, 20, 35, 50]}
        data={tableData}
        dropDownFilters={dropDownFilters}
        handleAddButton={handleAddRole}
      />
    </Container>
  );
};
